import React from "react";
import { useRetrieveProjects } from "@planzone/view-models";
import { InfiniteScrollRoot, Flag } from "@common/infiniteScroll";

import { Loader } from "../../../loader";
import { Props } from "./types";
import { Project } from "./project";
import styles from "./styles.scss";

function Projects({ zone, selected, onSelect }: Props) {
  const filter = { includeAllProjects: true, zones: [zone] };
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    projects,
    canRetrieveNextProjects,
    index,
    retrieveProjects,
  } = useRetrieveProjects(filter, "ascendingName", 10);

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjects({ filter, sort: "ascendingName", size: 10, index: 0 });
  }, []);

  return (
    <InfiniteScrollRoot canFetchOnIdle>
      <ul className={styles.projects}>
        {isRequestPending && projects.length === 0 ? (
          <Loader />
        ) : (
          [...projects]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((project) => (
              <li key={project.uuid}>
                <Project
                  project={project}
                  isSelected={selected?.uuid === project.uuid}
                  onSelect={() => onSelect(project)}
                />
              </li>
            ))
        )}
        {isRequestPending && projects.length > 0 && <Loader />}
        <Flag
          name={`assignToTaskZoneProjectsFlag-${zone.uuid}`}
          retrieveItems={() =>
            canRetrieveNextProjects &&
            !isRequestPending &&
            retrieveProjects({ filter, sort: "ascendingName", size: 10, index })
          }
          isDisabled={!canRetrieveNextProjects || isRequestPending}
        />
      </ul>
    </InfiniteScrollRoot>
  );
}

export { Projects };
